module.exports = __webpack_public_path__ + "static/img/swap.ff6989f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GoodsInfoCard/assets/swap.png
// module id = KwnS
// module chunks = 103